const routesWithClickjackProtectionDisabled = [
  ":instCode/modules/:moduleId/playlist",
  ":instCode/modules/:moduleId/resources/:resourceId/preview",
];

export default routesWithClickjackProtectionDisabled;
